import { combineReducers } from 'redux';
import commonReducer from 'modules/common/reducer';
import generalReducer from 'modules/general/reducer';
import orderReducer from 'modules/order/reducer';
import accountManagementReducer from 'modules/accountManagement/reducer';

export default combineReducers({
  common: commonReducer,
  general: generalReducer,
  order: orderReducer,
  accountManagement: accountManagementReducer,
});
